export default __webpack_public_path__ + "static/media/10.dd1da1db.jpg";